import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLanguages, getDictionaries, setCurrentLanguageClass, setCurrentLanguageIso } from '../Language/Language.action';


const LanguageMenu = () => {
    const dispatch = useDispatch();
    let languages = useSelector((state) => state.language.languages);
    let dictionaries = useSelector((state) => state.language.dictionaries);
    const [isSelectorOpened, setIsSelectorOpened] = useState(false);
    const [activeLanguage, setActiveLanguage] = useState("");

    const toggleLanguageSelector = () => {
        setIsSelectorOpened(!isSelectorOpened);
    }

    const selectLanguage = (iso) => {
        const className = `${iso}-icon`;
        dispatch(setCurrentLanguageIso(iso));
        dispatch(setCurrentLanguageClass(className));
        setActiveLanguage(className);

        const language = languages?.find(l => l.isoCode === iso);
        if (language?.url) {
            window.location.href = language.url;
        } else {
            console.error("No URL configured for language:", iso);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                languages = dispatch(await getLanguages());
                dictionaries = dispatch(await getDictionaries());
                const htmlElement = document.querySelector("html");
                let lang = "";
                if (htmlElement) {
                    lang = htmlElement.getAttribute("lang");
                }
                const className = `${lang}-icon`;
                dispatch(setCurrentLanguageIso(lang));
                dispatch(setCurrentLanguageClass(className));
                setActiveLanguage(className);
            } catch (error) {
                console.error('Error fetching languages:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (languages && languages.length > 0) {
            languages.sort((a, b) => {
                if (a.isDefault) return -1;
                if (b.isDefault) return 1;
                return 0;
            });
        }
    }, [languages]);

    return (
        <Fragment>
            {dictionaries && languages && activeLanguage &&(
                <div className="language__menu-container">
                    <div className="language__menu">
                        <div className="language__menu-content" onClick={() => toggleLanguageSelector()}>
                            <span className={"language__menu-content-flag " + activeLanguage} />
                            <p>{dictionaries.find(item => item.key === 'Languages')?.value ?? 'Languages'}</p>
                            <span className="language__menu-content-dropdown" />
                        </div>
                    </div>

                    {isSelectorOpened && languages && languages.length > 0 && (
                        <div className="language__selector">
                            <div className="language__selector__close" onClick={() => toggleLanguageSelector()}>
                                <span></span>
                                <p>{dictionaries.find(item => item.key === 'Back to categories')?.value ?? 'Back to categories'}</p>
                            </div>
                            <ul className="language__selector__list">
                                {languages.map((country, index) => (
                                    <li key={index} className={`language__selector__list__item ${activeLanguage === `${country.isoCode}-icon` ? 'language__selector__list__item-active' : ''}`} onClick={() => selectLanguage(country.isoCode)}>
                                        <div className="language__selector__list__item-container">
                                            <div>
                                                <span className={`language__selector__list__item-container-flag ${country.isoCode}-icon ${activeLanguage === `${country.isoCode}-icon` ? 'language__selector__list__item-container-flag-active' : ''}`} />
                                                <p className="language__selector__list__item-container-language">{country.languageName}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    );
};

export default LanguageMenu;
